import Component, { mixins } from 'vue-class-component'

import WithRender from './FicheRepondantConditionsOverlay.html'

import {
  MButton,
  MButtonSkin,
  MOverlay
} from '@ulaval/modul-components'
import { STORE_GETTERS } from '@/store'

@WithRender
@Component({
  components: {
    MButton,
    MOverlay
  }
})
export default class FicheRepondantConditionsOverlay extends mixins() {
  private isOverlayOpen: boolean = true

  private readonly MButtonSkin: object = MButtonSkin

  private get userFullName(): string | null {
    return this.$store.getters[STORE_GETTERS.SESSION_GET_USER_FULL_NAME]
  }

  private onHideOverlayButtonClick(): void {
    this.isOverlayOpen = false
  }
}
